import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { environment } from '@env';
import { LoaderService } from '@services/loader.service';
import { PagesService } from '@services/pages.service';
import { ChartDataset, ChartOptions, ChartType, TooltipItem } from 'chart.js';
import moment from 'moment';
// import { Color, Label } from 'ng2-charts';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wsb-landing-views',
  templateUrl: './landing-views.component.html',
  styleUrls: ['./landing-views.component.scss'],
  standalone: false
})
export class LandingViewsComponent implements OnInit {
  @Input() periods: any;
  @Input() loadingPeriod: any;
  @Input() page: any;

  public readonly today = new Date();

  pageVisitsByDay;
  pageClickByDay;
  dateFrom: UntypedFormControl = new UntypedFormControl();
  dateTo: UntypedFormControl = new UntypedFormControl();
  period: UntypedFormControl = new UntypedFormControl();

  public lineChartPerDayLegend = false;
  public lineChartPerDayType: ChartType = 'line';
  public lineChartPerDayOptions?: ChartOptions;
  public pageVisitsByDayData: ChartDataset[] = [];
  public pageUniqueVisitsByDayData: ChartDataset[] = [];
  public lineChartPerDayLabels: string[] = [];

  constructor(private pagesService: PagesService, private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.updateAxes();
    this.onSelectionChange(this.loadingPeriod);
  }

  getVisitByDay(idPage, dateFrom, dateTo) {
    if (!idPage) {
      return;
    }
    this.loaderService.show();
    this.pagesService
      .getPagesStatsGetVisitsByDay(idPage, this.fixDate(dateFrom), this.fixDate(dateTo))
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(visitByDay => {
        this.pageVisitsByDay = visitByDay;
        const chartDataTemplate = data => ({
          data: [...data],
          backgroundColor: 'rgba(0, 0, 0 , 0.0)',
          borderColor: environment.chartsColorPalette[0],
          pointBorderColor: environment.chartsColorPalette[0],
          pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        });

        this.pageVisitsByDayData = [chartDataTemplate(visitByDay.visits.values)];
        this.pageUniqueVisitsByDayData = [chartDataTemplate(visitByDay.uniqueVisits.values)];
      });
  }

  // getClickByDay(idPage) {
  //   this.pagesService.getPagesStatsGetClicksByDay(idPage).subscribe(clickByDay => {
  //     this.pageClickByDay = clickByDay;
  //   });
  // }

  onSelectionChange(period) {
    this.dateFrom.setValue(this.setDateForFc(period.dateFrom));
    this.dateTo.setValue(this.setDateForFc(period.dateTo));
    this.getVisitByDay(this.page?.idPage, period.dateFrom, period.dateTo);
  }

  search() {
    this.getVisitByDay(this.page?.idPage, this.dateFrom.value, this.dateTo.value);
  }

  fixDate(date) {
    return (
      moment(date)
        .format('YYYY-MM-DDTHH:mm:ss')
        .toString() + 'Z'
    );
  }

  setDateForFc(date) {
    return new Date(
      moment(date)
        .format('ddd MMM DD YYYY HH:mm:ss')
        .toString()
    );
  }

  private updateAxes(): void {
    this.lineChartPerDayOptions = {
      elements: {
        line: {
          tension: 0
        }
      },
      plugins: {
        tooltip: {
          mode: 'index',
          callbacks: {
            title(context: TooltipItem<ChartType>[]): string | string[] {
              return `${context[0].label} - ${context[0].raw}`;
            },
            label(context: TooltipItem<ChartType>): string | string[] {
              return undefined;
            }
          }
        }
      },
      responsive: true,
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            stepSize: 1,
            maxTicksLimit: 10
          }
        },
        x: {
          grid: {
            color: 'rgba(255,0,0,0.0)'
          }
        }
      }
    };
  }
}
